// Яндекс.Метрика — цели для отслеживания конверсий
// ID счётчика: 105613688

declare global {
  interface Window {
    ym: (id: number, action: string, goal: string, params?: object) => void
  }
}

const METRIKA_ID = 105613688

export const ym = {
  // 1. Клик на кнопку авторизации через Яндекс
  authYandexClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'auth_yandex_click')
  },

  // 2. Успешная авторизация (пользователь залогинился)
  authSuccess: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'auth_success')
  },

  // 3. Клик «Создать событие»
  createEventClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'create_event_click')
  },

  // 4. Событие успешно создано и опубликовано
  createEventSuccess: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'create_event_success')
  },

  // 5. Просмотр карточки события
  eventView: (eventId: string) => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'event_view', { eventId })
  },

  // 6. Клик «Участвовать» на событии
  eventJoinClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'event_join_click')
  },

  // 7. Клик по категории
  categoryClick: (categoryName: string) => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'category_click', { categoryName })
  },

  // 8. Клик «Все» события
  showAllClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'show_all_click')
  },

  // 9. Поиск события (EventPickerDialog)
  eventPickerOpen: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'event_picker_open')
  },

  // 10. Шаринг события
  tgChannelClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'tg_channel_click')
  },
  appStoreClick: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'app_store_click')
  },
  eventShare: () => {
    window.ym?.(METRIKA_ID, 'reachGoal', 'event_share')
  },
}
